// extracted by mini-css-extract-plugin
module.exports = {"authSection":"Login_authSection__HB1k7","column":"Login_column__eu5hA","auth":"Login_auth__QPAp_"};